<template>
  <div>
    <div class="top-search">
      <Search />
    </div>
    <Content
      style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);background-color: white;,"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <div>
        <!-- <h1 id="t1" style="font-family:'站酷酷黑体'">站酷酷黑体</h1>
    <h1 style="font-family:'站酷快乐体'">站酷快乐体</h1>
      <h1 style="font-family:'站酷黄油体'">站酷黄油体</h1>-->
      </div>

      <div v-if="isloading">
        <div class="progress-box" v-if="progress != 100">
          <el-progress type="circle" :percentage="progress"></el-progress>
        </div>
      </div>
      <div v-if="isSearchloading">
        <div class="progress-box" v-if="searchProgress <= 100">
          <el-progress type="circle" :percentage="searchProgress"></el-progress>
        </div>
      </div>
      <el-row :gutter="40" style="margin:  20px 0;">
        <el-col :span="10" class="leftMain">
          <el-tabs v-model="activeName" style="margin-left: 10px;">
            <el-tab-pane label="词频数据" name="first" class="scroll-pane">
              <SelectWordFrequency
                ref="select-word-frequency"
                :keyword="keyword"
                :type="type"
                @wordok="wordisok"
                @showLoading="showLoading"
                @clearWaterMark="clearWaterMark"
                @editwords="geteidtwords"
              ></SelectWordFrequency>
            </el-tab-pane>
            <el-tab-pane label="选择图案" name="second" class="scroll-pane">
              <SelectPattern
                ref="select-pattern"
                v-on:click.native="selectPatternClick"
                @goyuntu="generate"
                @setWaterMark="initWaterMark"
              ></SelectPattern>
            </el-tab-pane>
            <el-tab-pane label="选择字体" name="third" class="scroll-pane">
              <SelectFont ref="select-font" @changeFont="generate"></SelectFont>
            </el-tab-pane>
            <!-- <el-tab-pane label="设置布局" name="fourth" class="scroll-pane">
            <SelectLayout ref="select-layout"></SelectLayout>
          </el-tab-pane>
          <el-tab-pane label="设置样式" name="fifth" class="scroll-pane">
            <SelectStyle ref="select-style"></SelectStyle>
          </el-tab-pane>-->
          </el-tabs>
        </el-col>
        <el-col :span="14">
          <div style="display: flex;height: 40px;align-items: center">
            <el-row style="width: 100%">
              <el-col :span="10">
                <el-button
                  id="wordfrequency-refresh"
                  style="background-color: #ff6400;border-color: #ff6400;"
                  type="primary"
                  size="mini"
                  @click="generate"
                  :disabled="wordLoading"
                  icon="el-icon-refresh-right"
                  >刷新词云</el-button
                >
              </el-col>
              <el-col :span="14" style="text-align: right">
                <div
                  style=" float: left; position: relative; margin-left: 17px;"
                  v-if="showxt"
                >
                  <span class="xtbtn-box" style="position: relative;">
                    <a
                      id="akey"
                      class="xt"
                      :href="'//www.5118.com/xt/' + keyword"
                      target="_blank"
                    >
                      查看该选题
                    </a>
                    <span v-if="autotip" class="tigs">
                      点击查看该关键词行业选题<span
                        style="font-size: 15px;margin-left:10px;"
                        @click="closeautotip"
                        >×</span
                      >
                    </span>
                  </span>
                </div>

                <el-button
                  id="wordfrequency-shre"
                  type="info"
                  size="mini"
                  @click="userShare"
                  :disabled="wordLoading"
                  icon="el-icon-share"
                  class="checkbtn"
                  >分享</el-button
                >
                <el-button
                  id="wordfrequency-promotion"
                  type="info"
                  size="mini"
                  @click="publish"
                  :disabled="wordLoading"
                  icon="el-icon-s-promotion"
                  class="checkbtn"
                  >发布</el-button
                >
                <el-button
                  id="wordfrequency-download"
                  type="info"
                  size="mini"
                  icon="el-icon-download"
                  :disabled="wordLoading"
                  @click="download"
                  class="checkbtn"
                  >导出图片</el-button
                >
                <el-dialog
                  title="发布到共享"
                  :visible.sync="shareDialogVisible"
                  width="500px"
                  center
                  :close-on-click-modal="false"
                >
                  <span
                    >发布后，词云图片将公开到大数据词云共享库，所有用户都可以看到，供大家使用学习交流。</span
                  >
                  <div style="margin-top:20px">
                    <el-input
                      placeholder="请输入大数据词云标题"
                      v-model="input"
                      clearable
                    ></el-input>
                  </div>
                  <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="share"
                      >确定发布</el-button
                    >
                    <el-button @click="shareDialogVisible = false"
                      >取 消</el-button
                    >
                  </div>
                </el-dialog>

                <el-dialog
                  title="分享到微信朋友圈"
                  :visible.sync="dialogVisible"
                  width="500px"
                  center
                  :close-on-click-modal="false"
                >
                  <div style="margin: 0px auto;text-align: center;">
                    <vue-qr
                      class="bicode"
                      :logoSrc="shareImagePath"
                      :text="sharePath"
                    ></vue-qr>
                  </div>
                  <!-- <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                </span>-->
                </el-dialog>
              </el-col>
            </el-row>
          </div>

          <el-row class="imageContent">
            <div id="canvas-container">
              <!-- <img :src="resultImage" style="width: 610px;" /> -->
              <canvas
                ref="generateCanvas"
                width="610px"
                height="500px"
                id="canvas"
              ></canvas>
              <div
                style="height:500px;width: 610px;display:none"
                id="html-canvas"
              ></div>
              <canvas
                id="maskCanvasScaledOption"
                class="canvas"
                style="display:none"
              ></canvas>
            </div>
          </el-row>
        </el-col>
        <div
          class="userPermissionTip"
          v-if="waterMarkTip != ''"
          v-html="waterMarkTip"
        ></div>
        <!-- <div class="userPermissionTip" v-if="normalWaterMarkTip!=''" v-html="normalWaterMarkTip" ></div> -->
      </el-row>
    </Content>
  </div>
</template>
<style lang="less">
// @import url("../assets/font/font.css?v=021801");

#canvas-container {
  overflow-x: auto;
  overflow-y: visible;
  position: relative;
  margin-top: 20px;
  margin-bottom: 20px;
}
#box {
  pointer-events: none;
  position: absolute;
  box-shadow: 0 0 200px 200px rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  cursor: pointer;
}
#canvas-container :hover {
  cursor: pointer;
}
</style>
<script>
import {
  Run,
  maskImgChange,
  InitAndDrawImage,
  RepeatData
} from "../assets/script/utils/index.js";
import { mapActions, mapMutations } from "vuex";
import VueQr from "vue-qr";
import $ from "jquery";
import config from "../assets/script/config";
import axios from "axios";
import ioUtil from "../assets/script/utils/io";
import userUtil from "../assets/script/utils/userUtils";
import Cookies from "js-cookie";
import { async } from "q";
import Utils from "../assets/script/utils/util.js";

export default {
  name: "WordFrequency",
  // provide(){
  //   return{
  //     showLoading:this.showLoading
  //   }
  // },
  data() {
    return {
      keyword: this.$route.params.keyword,
      type: this.$route.params.type,
      mainGuid: null,
      imageSrc: "",
      autotip: true,
      input: "",
      shareDialogVisible: false,
      activeName: "first",
      resultImage: null,
      progress: 0,
      isloading: false,
      isSearchloading: false,
      searchProgress: 0,
      wordLoading: true,
      waterMarkTip: userUtil.getWaterMarkTip(),
      editwords: false,

      dialogVisible: false,
      sharePath: "", //显示的值、跳转的地址
      icode: "",
      shareImagePath: "", //中间logo的地址
      isCanShowPublishDialog: false,

      loading: false,
      loadingText: "词云正在保存中",
      showxt: false
    };
  },
  watch: {
    async $route(to) {
      this.mainGuid = null;
      this.keyword = to.params.keyword;
      this.type = to.params.type;
      this.$refs["select-word-frequency"].insertTask(this.keyword, this.type);
      this.activeName = "first";
      var xtmodel = await this.AXtCheckName({
        keyword: this.keyword,
        datatype: "akey"
      });
      this.showxt = xtmodel.data.isExists && xtmodel.data.auditState == 100;
    },
    isloading(val) {
      if (val) {
        this.loadingtime();
      }
    },
    searchProgress(val) {
      if (val >= 100) {
        this.generate();
        this.activeName = "second";
        this.isChecking = false;
        this.searchProgress = 0;
      }
    },
    editwords(val) {
      if (val) {
        this.generate();
      }
    }
  },
  computed: {
    isChecking: {
      get() {
        return this.$store.state.wordfre.isChecking;
      },
      set(val) {
        this.$store.state.wordfre.isChecking = val;
      }
    }
  },
  components: {
    SelectPattern: () => import("../components/edit/SelectPattern"),
    SelectFont: () => import("../components/edit/SelectFont"),
    SelectWordFrequency: () => import("../components/edit/SelectWordFrequency"),
    Search: () => import("../components/share/Search"),
    // SelectLayout: () => import('../components/edit/SelectLayout'),
    // SelectStyle: () => import('../components/edit/SelectStyle')
    VueQr
  },
  created() {
    this.refreshLevel();

    let _this = this;
    Utils.$on("refreshLevel", function() {
      // console.log('refreshLevel on ');
      _this.refreshLevel();
    });
  },
  async mounted() {
    this.MSetMenu("/edit");
    $("#canvas").mouseleave(function() {
      //解决鼠标离开遮罩层没有取消
      $("#box").prop("hidden", true);
    });
    var xtmodel = await this.AXtCheckName({
      keyword: this.keyword,
      datatype: "akey"
    });
    this.showxt = xtmodel.data.isExists && xtmodel.data.auditState == 100;
  },
  methods: {
    ...mapActions("core", [
      "AGenerate",
      "AShare",
      "ADownload",
      "AgetImageTest",
      "AUpdateClickTime",
      "AXtCheckName"
    ]),
    ...mapMutations("menu", ["MSetMenu"]),
    ...mapMutations("user", ["MSet"]),
    selectPatternClick() {
      let userLevel = userUtil._getUserLevel();
      let markUrl = userLevel == "" ? config.waterMaskImageUrl : "";
      // alert('3'+markUrl);
      this.waterMarkTip = userUtil.getWaterMarkTip();
      // //初始化大图
      // maskImgChange(
      //   this.$refs["select-pattern"].getImageUrl().split("?")[0],
      //   markUrl
      // );
    },
    //修改词频数后生成云图
    geteidtwords(data) {
      this.editwords = data;
    },
    showLoading4DownloadFont(isShow) {
      //字体的loading
      if (isShow) {
        this.loading = true;
        this.loadingText = "字体加载中...";
      } else {
        //关闭loading
        this.loading = false;
      }
    },
    refreshLevel() {
      var _this = this;

      //刷新用户等级
      let user = Cookies.get("user");
      if (user) {
        var loginLink =
          process.env.NODE_ENV === "development"
            ? "http://localhost:8081/api/account/GetLevel"
            : "https://ciyun.5118.com/api/account/GetLevel";
        //loginLink = "http://localhost:8081/api/account/GetLevel";

        fetch(loginLink, {
          headers: {
            Authorization: JSON.parse(user).token
          }
        })
          .then(res => res.text())
          .then(function(res) {
            var jsonObgj = JSON.parse(res);
            if (jsonObgj.errorCode == 0) {
              _this.waterMarkTip = userUtil.getWaterMarkTip(
                jsonObgj.data.level
              );

              var exp = new Date();
              exp.setTime(exp.getTime() + 99999 * 24 * 60 * 60 * 1000);
              Cookies.set("userLevel", jsonObgj.data.level, {
                expires: exp
              });
            }
            // return JSON.parse(res).data.level;
          });
      }
      return "";
    },
    generate() {
      let token = this._getToken();
      if (!token) {
        this.$alert("请先进行登录后再操作");
        this.MSet(null);
        return;
      }
      let userLevel = userUtil._getUserLevel();
      let getimg = this.$refs["select-pattern"].getImageUrl();
      if (!getimg) {
        this.$alert("请选择要生成的图案");
        return;
      }
      var $canvas = $("#canvas");
      var $htmlCanvas = $("#html-canvas");
      var maskImageUrl = this.$refs["select-pattern"].getImageUrl();

      var words = this.$refs["select-word-frequency"].list;
      words = words || [];

      //方便调试
      // words.splice(100, 500);
      if (words.length < 1500) {
        //填充词
        var newWordsList = RepeatData(words, 1300);
        if (newWordsList && newWordsList.length > 0) {
          words = newWordsList;
        }
      }

      //选择的字体
      var fontFamily = this.$refs["select-font"].activeFont || "微软雅黑";
      var fontUrl = this.$refs["select-font"].fontUrl;

      //先移除hover的遮罩层，避免无限叠加
      var box_dom = document.getElementById("box");
      var parent = document.getElementById("canvas-container");
      if (box_dom != null) {
        parent.removeChild(box_dom);
      }

      var $box = $('<div id="box" hidden />');
      var container = $("#canvas-container");

      //下拉框类型naotu/yuliao
      var selectType = this.type;
      //搜索的关键词
      var keyword = this.keyword;
      var loadingFunction = this.showLoading4DownloadFont;
      InitAndDrawImage(
        words,
        $canvas,
        $htmlCanvas,
        userLevel,
        maskImageUrl,
        fontFamily,
        $box,
        container,
        keyword,
        selectType,
        fontUrl,
        loadingFunction
      );
      // this.showLoading4DownloadFont(false);

      //监听前先取消监听，否则会重复多次
      // $("#canvas").off("wordcloudstart");
      // $("#canvas").on("wordcloudstart", function () {
      //   //开锁
      //   this.lock = false;
      //   console.log('end 锁');
      //   console.log(this.lock);
      //   // loading.close();
      // });

      //this.submiteGenerate()
      this.AUpdateClickTime({
        typeId: this.$refs["select-pattern"].activePatternTypeId,
        photoName: getimg
      });
    },

    // 定义一个深拷贝函数  接收目标target参数
    deepClone(target) {
      // 定义一个变量
      let result;
      // 如果当前需要深拷贝的是一个对象的话
      if (typeof target === "object") {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
          result = []; // 将result赋值为一个数组，并且执行遍历
          for (let i in target) {
            // 递归克隆数组中的每一项
            result.push(this.deepClone(target[i]));
          }
          // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
          result = null;
          // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
          result = target;
        } else {
          // 否则是普通对象，直接for in循环，递归赋值对象的所有值
          result = {};
          for (let i in target) {
            result[i] = this.deepClone(target[i]);
          }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
      } else {
        result = target;
      }
      // 返回最终结果
      return result;
    },
    loadingtime() {
      let pictime = setInterval(() => {
        if (this.progress >= 98) {
          clearInterval(pictime);
        } else {
          this.progress += 1;
        }
      }, 70);
    },
    download() {
      let type = "png";
      let data = this.$refs.generateCanvas.toDataURL(type);
      let filename = "快推易kt1.com云图_" + this.keyword + "." + type;
      let save_link = document.createElementNS(
        "http://www.w3.org/1999/xhtml",
        "a"
      );
      save_link.href = data;
      save_link.download = filename;

      let event = document.createEvent("MouseEvents");
      event.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      save_link.dispatchEvent(event);

      // if (!this.mainGuid) {
      //   this.$notify({ message: "请先生成大数据词云" });
      //   return;
      // }
      // this.ADownload({ mainGuid: this.mainGuid });
    },
    /**
     * 分享发布
     */
    async share() {
      //alert(this.mainGuid==null)
      this.shareDialogVisible = false;
      await this.AShare({
        shareName: this.input,
        mainGuid: this.mainGuid
      });
      this.$notify({ message: "发布成功" });
    },
    showLoading(data) {
      this.isSearchloading = data.status;
      this.searchProgress = data.prop;
    },
    wordisok(data) {
      this.wordLoading = data;
    },
    async userShare() {
      this.loading = true;
      this.loadingText = "词云正在保存中";
      await this.submiteGenerate();
      this.loading = false;
      if (this.mainGuid != null) {
        //http://localhost:8080
        process.env.NODE_ENV === "development"
          ? (this.sharePath = `http://localhost:8080/detail/${this.mainGuid}`)
          : (this.sharePath = `https://ciyun.5118.com/detail/${this.mainGuid}`);

        //this.sharePath=`http://localhost:8080/detail/${this.mainGuid}`;
        //alert(this.sharePath)
        this.dialogVisible = true;
      } else {
        this.$notify({ message: "请先生成大数据词云" });
      }
    },
    clearWaterMark() {
      // this.waterMarkTip = "";
    },
    readFile() {
      var file = this.file;
      //判断是否是图片类型
      /*if (!/image\/\w+/.test(file.type)) {
            alert("只能选择图片");
            return false;
        }*/
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        // txshow.src = this.result;
      };
    },
    async publish() {
      this.input = this.keyword;
      this.loading = true;
      this.loadingText = "词云正在保存中";
      await this.submiteGenerate();
      this.loading = false;
      if (this.mainGuid == null) {
        this.$notify({ message: "保存数据失败" });
        return;
      }
      this.shareDialogVisible = true;
    },
    async submiteGenerate() {
      let getimg = this.$refs["select-pattern"].getImageUrl();
      if (!getimg) {
        this.$notify({ message: "请选择要生成的图案" });
        return;
      }

      this.file = ioUtil.dataURLtoFile(this.$refs.generateCanvas.toDataURL());

      let dataJSON = JSON.stringify({
        image: this.$refs["select-pattern"].getImageUrl(),
        content: this.$refs["select-word-frequency"].getResultList(),
        font: this.$refs["select-font"].activeFont
        //layout: this.$refs["select-layout"].getResultLayout(),
        //style: this.$refs["select-style"].getResultStyle(),
      });

      const form = new FormData();
      form.append("file", this.file);
      form.append("dataType", this.type);
      if (this.mainGuid != null) {
        form.append("mainGuid", this.mainGuid);
      }
      form.append("keyword", this.keyword);
      form.append("dataJSON", dataJSON);
      form.append("typeId", this.$refs["select-pattern"].activePatternTypeId);

      try {
        var result = (
          await axios.post("/api/wordcloud/generate", form, {
            headers: {
              Authorization: this._getToken(),
              "Content-Type": "multipart/form-data"
            }
          })
        ).data;

        if (result.errorCode) {
          this.$notify({ message: result.errorMess });
          return;
        }
        //         if (result.data.userLevel == "") {
        //           this.waterMarkTip = `升级为5118付费会员,即可去除水印     <a href='https://account.5118.com/member?m=vip&p=wordcloudgenerate&b=up&r=0' style='color:white; text-decoration: underline;
        // }'>   我要升级</a>`;
        //         } else {
        //           this.waterMarkTip = `亲爱的5118${
        //             result.data.userLevel
        //           }用户,我们已为您自动去除水印`;
        //         }
        this.mainGuid = result.data.mainGuid;
      } catch (e) {
        this.$notify({ message: `保存数据失败` });
      }
    },
    _getToken() {
      //return "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUyODIzNSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3NpZCI6IjUyODIzNSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvZXhwaXJhdGlvbiI6IjMvMy8yMDIwIDk6MDU6MzMgQU0iLCJuYmYiOjE1ODEwNjYzMzMsImV4cCI6MTU4MzIyNjMzMywiaWF0IjoxNTgxMDY2MzMzLCJpc3MiOiJ3d3cuNTExOC5jb20iLCJhdWQiOiJ3d3cuNTExOC5jb20ifQ.-Z839y2T-qUzZswhY8oHIbF3WsopKC6K6N3utq6NwG0";
      let user = Cookies.get("user");
      if (user) {
        return JSON.parse(user).token;
      }
      return "";
    },
    initWaterMark() {
      // this.waterMarkTip = userUtil.getWaterMarkTip();
    },
    closeautotip: function() {
      this.autotip = false;
    }
  }
};
</script>
<style type="text/less" lang="less" scoped>
.scroll-pane {
  height: 640px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 15px;
}
.progress-box {
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: rgba(255, 255, 255, 0.7);
}
.userPermissionTip {
  background: #f4b841;
  font-size: 13px;
  color: white;
  border: 1px#f4b841 solid;
  border-radius: 30px 0 0 30px;
  text-align: right;
  padding: 2px 5px 2px 10px;
  width: auto;
  float: right;
  position: absolute;
  right: 17px;
  bottom: 1px;
}
.imageContent {
  background-color: white;
  border: 1px#e5e5e5 solid;
}
.leftMain {
  background-color: #f9f9f9;
  border: 1px #e5e5e5 solid;
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.checkbtn {
  background-color: #fff;
  border-color: #c4c4c4;
  color: #666666;
}

.top-search {
  overflow: hidden;
  text-align: center;
  margin: 20px 0 15px;
  clear: both;
}

.xtbtn-box .xt {
  padding: 0 3px;
  line-height: 27px;
  border: 1px solid #2677f2;
  border-radius: 4px;
  color: #2677f2 !important;
  text-decoration: none !important;
  cursor: pointer;
  background-color: white !important;
  display: inline-block;
  font-size: 14px;
}
.tigs {
  position: absolute;
  top: 31px;
  left: 0px;
  z-index: 100;
  height: 25px;
  line-height: 25px;
  padding: 0 5px;
  border: 1px solid #fed8a0 !important;
  color: #fea638 !important;
  text-align: center;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 5px;
  background: #fef8e4 !important;
  white-space: nowrap;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  font-weight: normal !important;
}
.tigs:before {
  content: "";
  display: block;
  position: absolute;
  height: 8px;
  width: 8px;
  transform: rotate(-136deg);
  background-color: #fef8e4 !important;
  bottom: 19px;
  left: calc(22% - 4px);
  border-right: 1px solid #fed8a0 !important;
  border-bottom: 1px solid #fed8a0 !important;
}
</style>
